import { useTranslation } from "react-i18next"
import { SquareArrowOutUpRight } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { config } from "@/config"

export function DialogDiagnoseIssue() {
  const { t } = useTranslation()

  return (
    <DialogContent className="max-w-3xl">
      <DialogHeader>
        <DialogTitle>{t("header.diagnoseIssue.title")}</DialogTitle>
      </DialogHeader>
      <DialogBody
        className="
          flex flex-col gap-6
          lg:flex-row
        "
      >
        <div
          className="
            flex flex-col space-y-4
            lg:w-5/13
          "
        >
          <p className="font-extralight">
            {t("header.diagnoseIssue.description")}
          </p>
          <div className="space-y-2">
            <h4 className="font-h4-bold">
              {t("header.diagnoseIssue.instruction.title")}
            </h4>
            <div className="flex flex-col gap-1 space-y-1 text-sm">
              <span>{t("header.diagnoseIssue.instruction.one")}</span>
              <Button
                variant="outline"
                size="sm"
                className="mt-4 w-full"
                onClick={() =>
                  window.open(
                    `https://tools.connect.aws/endpoint-test/?connectInstanceUrl=https://${config.connectInstanceAlias}.my.connect.aws&regions=ap-northeast-1&autoRun=true`,
                    "_blank",
                  )
                }
              >
                {t("header.diagnoseIssue.button")}
                <SquareArrowOutUpRight className="size-4" />
              </Button>
              <span>{t("header.diagnoseIssue.instruction.two")}</span>
              <span>{t("header.diagnoseIssue.instruction.three")}</span>
              <span>{t("header.diagnoseIssue.instruction.four")}</span>
            </div>
          </div>
        </div>
        <div
          className="
            flex items-start justify-center
            lg:w-8/13
          "
        >
          <img
            src="/pictures/diagnose_instruction.webp"
            alt="Diagnose Issue Instructions"
            className="
              max-w-full rounded-md object-contain
              lg:max-w-sm
            "
          />
        </div>
      </DialogBody>
    </DialogContent>
  )
}
